import React from "react";
import { FiSearch } from "react-icons/fi";
import { Link } from "react-router-dom"; // ✅ Added

const JobListings = () => {
  const jobs = [
    {
      title: "In charge – OPD – Indore",
      category: "Nursing",
      type: "Full Time",
      experience: "5–9 years",
      location: "Indore",
      qualification: "GNM / B. Sc (Nursing)",
    },
    {
      title: "In charge – OPD – Indore",
      category: "Nursing",
      type: "Full Time",
      experience: "5–9 years",
      location: "Indore",
      qualification: "GNM / B. Sc (Nursing)",
    },
    {
      title: "In charge – OPD – Indore",
      category: "Nursing",
      type: "Full Time",
      experience: "5–9 years",
      location: "Indore",
      qualification: "GNM / B. Sc (Nursing)",
    },
  ];

  return (
    <section className="jobs-section">
      <h2 className="section-title">Featured Jobs</h2>

      <div className="search-bar">
        <input type="text" placeholder="Search articles..." />
        <FiSearch className="search-icon" />
      </div>

      <div className="filters">
        <select>
          <option>All Job Category</option>
          <option>Nursing</option>
          <option>Doctor</option>
          <option>Technician</option>
        </select>

        <select>
          <option>All Job Types</option>
          <option>Full Time</option>
          <option>Part Time</option>
          <option>Contract</option>
        </select>

        <select>
          <option>All Job Location</option>
          <option>Indore</option>
          <option>Mumbai</option>
          <option>Delhi</option>
        </select>

        <select>
          <option>All Experience</option>
          <option>0–2 years</option>
          <option>2–5 years</option>
          <option>5–9 years</option>
        </select>

        <select>
          <option>All Qualification</option>
          <option>GNM</option>
          <option>B. Sc (Nursing)</option>
          <option>MBBS</option>
        </select>
      </div>

      <h3 className="sub-title">Current Openings at Kangaroo Care</h3>
      <hr className="divider" />

      <div className="job-list">
        {jobs.map((job, index) => (
          <div className="job-card" key={index}>
            <h4 className="job-title">{job.title}</h4>
            <hr />
            <div className="job-info">
              <span>🩺 {job.category}</span>
              <span>⏰ {job.type}</span>
              <span>📅 {job.experience}</span>
              <span>📍 {job.location}</span>
              <span>📄 {job.qualification}</span>

              {/* ✅ Link to JobDetails page */}
              <Link to="/jobdetails" className="learn-more">
                Learn more →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default JobListings;
